export default "__VITE_ASSET__DVyx1pJ3__"